// extracted by mini-css-extract-plugin
export var shake = "_m-1";
export var toastCloseButton = "_m-0";